import {
    apiRequest,
    presensiList,
    presensiActive,
    presensiInactive
} from "../../../../../services/adapters/kepegawaian/integrasiService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", presensiList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", presensiInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", presensiActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository